import xhr from 'xhr';

export default async function atrasados() {
  const res = await xhr(`/students?filters[id][$eq]=1`);
  return res.data.data;
}
